import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
  Theme,
} from '@mui/material';
import { tannerGray } from '../colors';

type MuiSkeleton = {
  styleOverrides?: ComponentsOverrides<Theme>['MuiSkeleton'];
  defaultProps?: ComponentsProps['MuiSkeleton'];
  variants?: ComponentsVariants['MuiSkeleton'];
};
export const MuiSkeleton: MuiSkeleton = {
  styleOverrides: {
    root: {
      backgroundColor: tannerGray['200'],
    },
  },
};
